module.exports = __webpack_public_path__ + "static/media/coming-soon-mobile.2bf216c7.jpg";